import { Card, LineEvent, LineState, Mode, PieState, SelectOptionsId } from '../types/index'
import Utils from 'live/lib/utils'
import i18n from 'live/services/i18n'

export const type = 'newPanel'
export const name = i18n('Monitoring Overview Panel')
export const description = i18n('Summary of basic information from all active rigs.')
export const queryHandlerKind = 'monitoringOverviewPanel'

export function getPointFormattedValue(point: LiveChartPoint): string {
    return typeof point.formattedValue === 'string' || typeof point.formattedValue === 'number'
        ? point.formattedValue
        : typeof point.y === 'number'
            ? Utils.formatNumber(point.y, 2, 2)
            : point.y
}

export const dataLabelForPoint = function (value, total) {
    if (value / total < 0.06) {
        return {
            enabled: false
        }
    }

    return {}
}

export function formatTimestampToDate(ts: string): string {
    const date = new Date(Number(ts))
    const dformat =
        [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-') +
        ' ' +
        [
            date.getHours()?.toString()?.length === 1 ? `0${date.getHours()}` : date.getHours(),
            date.getMinutes()?.toString()?.length === 1 ? `0${date.getMinutes()}` : date.getMinutes()
        ].join(':')

    return dformat
}

export function checkAndMountTimestamp(tsBegin: string, tsEnd: string): string {
    let span = 'last 24 hours'
    if (tsBegin) {
        const ts1 = `${tsBegin ?? 0}`
        const ts2 = `${tsEnd ?? 0}`

        span =
            ts1 === '0' && ts1.length === 1 && ts2 === '0' && ts2.length === 1
                ? 'last 24 hours'
                : ts1 !== '0' && ts2 === '0'
                ? `${formatTimestampToDate(ts1)} to now`
                : `${formatTimestampToDate(ts1)} to ${formatTimestampToDate(ts2)}`
    }

    return span
}

export function setDashboardTimespan(dashboardCtx: LiveDashboardContextValue, span: string): void {
    if (!dashboardCtx) {
        return
    }

    if (
        typeof dashboardCtx.actions.setTimespan === 'function' &&
        typeof dashboardCtx.getWidgetStateForIndex === 'function'
    ) {
        dashboardCtx.actions.setTimespan('from ts 0', undefined, false)
        // dashboardCtx.actions.setTimespan(span, undefined, true)
    }
}

export const chartEvents = (
    state: LineState | PieState,
    chartEvent: LineEvent[] | Record<string, unknown>[] = [],
    rigName: string
) => {
    let event = {
        ...state,
        events: []
    }

    if (rigName && chartEvent[rigName]) {
        event = {
            ...event,
            events: chartEvent[rigName]
        }
    }

    return event
}

export const sortRigs = (cards: Card[]): Card[] => {
    return cards
        .sort((a, b) => {
            if (a.rigName < b.rigName) {
                return -1
            }

            if (a.rigName > b.rigName) {
                return 1
            }

            return 0
        })
        .sort((a, b) => {
            if (a.rigName?.toLocaleUpperCase()?.startsWith('NS') || a.rigName?.toLocaleUpperCase()?.startsWith('SS')) {
                return -1
            }

            return 0
        })
}

const pxToGridY = (y: number): number => (y + 10) / 20

export const resizeY = (
    dashboardContext: LiveDashboardContextValue,
    mode: Mode,
    id: string | number,
    y: number
): void => {
    if (!dashboardContext) {
        return
    }
    const dashboardCFG = { ...dashboardContext }
    const shallowCFG: LiveDashboardContextValue = { ...dashboardCFG }
    const { actions, dashboard } = shallowCFG

    if (dashboard?.jsonConfig && dashboard?.jsonConfig?.layoutModes) {
        dashboard.jsonConfig.layoutModes[mode].grid[String(id)].size_y = pxToGridY(y)
        dashboard.jsonConfig.layoutModes[mode].gridRowHeight = 'static'
        const {
            jsonConfig: { layoutModes }
        } = dashboard
        actions.updateUserLayout(layoutModes[mode])
    }
}

export const mountLinkAndRedirect = (dashboardTitle: string, options: SelectOptionsId, asset: string): void => {
    const dashboardId = options.filter(o => o.label === dashboardTitle)[0].id
    if (dashboardId && typeof dashboardId === 'number') {
        const url = `/#/dashboard/${dashboardId}?filter={\"asset_name_event_type\":[\"${asset}\"]}&span=last month`
        window.open(url, '_blank')
    }
}
